import React from "react";
import { NavLink, Outlet, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, LayoutDashboard, Package, FileText, MessageSquare, Home, Gift } from "lucide-react";

const LINKS = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/quotes", label: "Quotes", icon: MessageSquare },
  { to: "/admin/sample-boxes", label: "Sample Boxes", icon: Gift },
  { to: "/admin/blog", label: "Blog", icon: FileText },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();

  if (loading) return <div className="min-h-screen grid place-items-center bg-white text-brand-stone">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-white flex" data-testid="admin-layout">
      <aside className="w-64 bg-brand-ink text-white flex flex-col p-6 sticky top-0 h-screen">
        <Link to="/" className="flex items-center gap-2 mb-10">
          <img
            src="https://customer-assets.emergentagent.com/job_bakery-b2b/artifacts/klxy49l5_Karpatka.png"
            alt="Cake World"
            className="w-12 h-12 object-contain bg-white rounded-full p-1"
          />
          <div>
            <div className="font-display text-lg leading-tight italic">Cake World</div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-brand-pink">Admin</div>
          </div>
        </Link>

        <nav className="flex-1 space-y-1">
          {LINKS.map((l) => (
            <NavLink
              key={l.to} to={l.to} end={l.end}
              data-testid={`admin-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm transition ${
                isActive ? "bg-white/10 text-white" : "text-white/70 hover:bg-white/5"
              }`}
            >
              <l.icon className="w-4 h-4" /> {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="mt-6 space-y-2">
          <Link to="/" data-testid="admin-view-site" className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm text-white/70 hover:bg-white/5">
            <Home className="w-4 h-4" /> View site
          </Link>
          <button
            onClick={logout} data-testid="admin-logout"
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm text-white/70 hover:bg-white/5"
          >
            <LogOut className="w-4 h-4" /> Sign out
          </button>
          <div className="mt-4 pt-4 border-t border-white/10 text-[11px] text-white/50">Signed in as<br/><span className="text-white/80">{user.email}</span></div>
        </div>
      </aside>

      <main className="flex-1 p-10 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
